module.exports = __webpack_public_path__ + "static/media/home-background.f5462c09.png";